var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"sidebar-geography"},[_c('v-list-item',[_c('geography-selector')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }